import {createSelector} from 'reselect';
import {availableRoutes, getRoutes} from '../routes';
import {getBaseUrlPath} from './system';

const getCreatedRoute = createSelector(
    [getBaseUrlPath],
    (baseRoute) => {
        return getRoutes(baseRoute);
    }
);

function _findRouteInRoutes(routes, routeId) {
    return (
        Object.keys(routes).find((route) => {
            return routes[route].id === routeId;
        }) || ''
    );
}

const getOwnerProfileRoute = createSelector(
    [getCreatedRoute],
    (routes) => {
        return _findRouteInRoutes(routes, availableRoutes.OWNER_PROFILE);
    }
);

export default {
    getOwnerProfileRoute
};

export {getOwnerProfileRoute, _findRouteInRoutes};
